import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import { Menu } from '@/components/navigation/Menu'

export const SecondaryNavRouter = ({ pages, activePage = pages[0].label }) => {
  const [currentPageLabel, setCurrentPageLabel] = useState(activePage)
  const history = useHistory()

  const changePage = (label, url) => {
    setCurrentPageLabel(label)
    if (url) {
      history.push(url)
    }
  }

  const currentComponent = pages.find((page) => page.label === currentPageLabel)

  return (
    <div data-testid="secondary-nav-router">
      {pages.length > 1 && (
        <Menu
          menuStyle="bar"
          className="mb"
          data-testid="secondary-nav-link"
          items={pages.map((page) => ({
            accessor: page.label,
            label: page.label,
            active: page.label === currentPageLabel,
            onClick: () => changePage(page.label, page.url),
            dataTestId: `secondary-nav-link-${page.label}`,
          }))}
        />
      )}
      {currentComponent?.component}
    </div>
  )
}
